import Vue from 'vue';
import DonationForm from './DonationForm.vue';
Vue.component('donation-form', DonationForm);
